module.exports = __webpack_public_path__ + "img/GH-kyujin-marketing002.de677d51.webp";